import address from 'translations/en/components/address'
import attachments from 'translations/en/components/attachments'
import billingDetails from 'translations/en/components/billingDetails'
import comments from 'translations/en/components/comments'
import hooks from 'translations/en/components/hooks'
import notification from 'translations/en/components/notification'
import payCodes from 'translations/en/components/payCodes'
import recurrenceRule from 'translations/en/components/recurrenceRule'
import topBar from 'translations/en/components/topBar'
import feedback from 'translations/en/components/feedback'
import versions from 'translations/en/components/versions'
import scheduleIssues from 'translations/en/components/scheduleIssues'
import employeeRequestsSummary from 'translations/en/components/employeeRequestsSummary'
import employeeTimeOffRequests from 'translations/en/components/employeeTimeOffRequests'

export default {
  address,
  attachments,
  billingDetails,
  comments,
  feedback,
  hooks,
  notification,
  payCodes,
  recurrenceRule,
  topBar,
  versions,
  scheduleIssues,
  employeeRequestsSummary,
  employeeTimeOffRequests,
  ACTIONS: `Actions`,
  USER_DELETED: `User deleted`,
  USER_UNASSIGNED: `Unassigned`,
  ATTRIBUTE_DELETED: `Attribute deleted`,
  RANK_DELETED: `Level deleted`,
  HIRING_DATA_DELETED: `Hiring data deleted`,
  PROJECT_DELETED: `Project deleted`,
  POSITION_DELETED: `Position deleted`,
  REQUEST_TYPE_DELETED: `Request type deleted`,
  PROCEDURE_DELETED: `Procedure deleted`,
  PUNCH_RULE_DELETED: `Punch rule deleted`,
  SORT_DELETED: `Sort deleted`,
  CONFIG_DELETED: `Config deleted`,
  FILTER_DELETED: `Filter deleted`,
  TAG_DELETED: `Tag deleted`,
  BREAK_DELETED: `Break deleted`,
  WAGE_PREMIUM_DELETED: `Wage premium deleted`,
  OVERTIME: `Overtime`,
  REGULAR: `Regular`,
  TEAM_DELETED: `Team deleted`,
  PERMISSION_DELETED: `Permission deleted`,
  DEPARTMENT_DELETED: `Department deleted`,
  SCHEDULE_TEMPLATE_DELETED: `Schedule template deleted`,
  STAFF_WARNING: `You are on a customer system, be careful.`,
  MISSING_PERMISSIONS: `You do not have the required permissions to view this`,
  NO_ADDRESS: `No address`,
  NO_HIRING_DATA: `No hiring data`,
  NO_SPECIFIC_RESTRICTIONS: `No specific restrictions`,
  NO_DATES: `No dates`,
  NO_SORT: `No sort`,
  NO_FILTER: `No filter`,
  NO_CONFIG: `No config`,
  NO_PROCEDURE: `No procedure`,
  DATES_FILTER: `Selected dates: {{start}} to {{end}}`,
  CLICK_TO_ADD_DATE_FILTER: `Click to filter by dates`,
  CREATED_AT: `Created at`,
  UPDATED_AT: `Updated at`,
  APPROVED_AT: `Approved at`,
  noResults: {
    NO_RESULTS_FOUND: `No results found`,
    CHANGE_FILTER: `Try changing the filters`,
    CHANGE_VIEW: `Enable 'Empty rows' to see all rows`
  },
  filtersChange: {
    FILTERS_HAVE_CHANGED: `Filters have changed`,
    SEARCH_LINK: `Click here to apply the new filters`
  },

  RADIO: {
    LABEL: ``,
    OPTIONS: {
      YES: {
        LABEL: `Yes`,
        DESCRIPTION: ``
      },
      NO: {
        LABEL: `No`,
        DESCRIPTION: ``
      }
    }
  },
  table: {
    MINUTES: `minutes`,
    HOURS: `hours`,
    DAYS: `days`,
    WEEKS: `weeks`,
    TENTATIVES: `tentatives`,
    NOTHING_TO_DISPLAY: `Nothing to display`,
    NOTHING_ON_THIS_PAGE: `Nothing on this page`,
    LOADING_ITEMS: `Loading resources`,
    TOOLS: `Tools`,
    EXPORT_AS_CSV: `Export as CSV`,
    EXPORT_AS_PDF: `Export as PDF`,
    HIDE_ARCHIVED: `Hide archived resources`,
    LOAD_ARCHIVED: `Load archived resources`,
    EXPORT: `Exports`,
    SYNC: `Sync`,
    FILTERS_HAVE_CHANGED: `Filters have changed`,
    SEARCH_LINK: `Click here to apply the new filters`
  },
  PROGRESS_MODAL: {
    TITLE: `Progression`,
    SUMMARY: `Please wait while the changes are applied.`
  },
  sync: {
    TITLE: `Resources sync`,
    SUMMARY: ``,
    JOB_PICKED_UP: `Job picked up`,
    FETCHING_TAGS: `Fetching tags`,
    PARSING_DATA: `Parsing data`,
    COMPUTING_DIFFS: `Computing diffs`,
    CREATING_NEW_TAGS: `Creating new tags`,
    UPDATING_TAGS: `Updating tags`,
    FETCHING_PROJECTS: `Fetching projects`,
    CREATING_NEW_PROJECTS: `Creating new projects`,
    UPDATING_PROJECTS: `Updating projects`,
    SYNC_RESULTS: `Sync results`,
    REFRESH: `Refresh`,
    CREATED: `{{toCreate}} created`,
    UPDATED: `{{toUpdate}} updated`
  },
  dayOfWeek: {
    0: `Sunday:`,
    1: `Monday:`,
    2: `Tuesday:`,
    3: `Wednesday:`,
    4: `Thursday:`,
    5: `Friday:`,
    6: `Saturday:`
  },
  dayOfWeekNoColon: {
    0: `Sunday`,
    1: `Monday`,
    2: `Tuesday`,
    3: `Wednesday`,
    4: `Thursday`,
    5: `Friday`,
    6: `Saturday`
  },
  availabilities: {
    AVAILABLE_ALL_DAY: `Available`,
    NOT_AVAILABLE_ALL_DAY: `Unavailable`,
    NOT_AVAILABLE: `Not available`,
    PREFER_TEXT: `Prefer`,
    UNAVAILABLE_TEXT: `Unavailable`,
    AVAILABLE_TEXT: `Available`,
    SHOW_CHANGES: `Show changes`,
    HIDE_CHANGES: `Hide changes`,
    FROM_TIME: `from`,
    TO_TIME: ` to `
  },
  sort: {
    REQUESTDATE: `Request date`,
    CREATIONDATE: `Creation date`,
    START: `Start`,
    END: `End`,
    VALIDATEDATE: `Validation date`,
    LASTUPDATEDATE: `Last update date`,
    VALIDITY: `Validity date`
  },
  importFieldCode: {
    MISSING_CODES: `If the resource you are looking for isn't displayed, please add an import code to it.`,
    EDIT_RESOURCES: `Edit the resources`,
    SHOW_IMPORT_CODE: `(Show import codes)`,
    IMPORT_CODES: `Import codes (click to show)`
  },
  addResource: {
    NO_RESOURCES: `There are no resources available.`,
    ADD_RESOURCES: `Add new resources here.`,
    NO_PERMISSION: `Please contact your administrator to add resources.`
  },
  resetPassword: {
    RESET_PASSWORD_MODAL: {
      TITLE: `Reset your password`,
      SUMMARY: ``
    }
  },
  END_TIME_BEFORE_START_TIME: `The end time must be after the start time.`,
  END_DATE_BEFORE_START_DATE: `The end date must be after the start date.`,
  NOTHING_TO_DISPLAY: `Nothing to display`,
  VIEW_LESS: `View less`,
  VIEW_MORE: `View more`,
  READ_LESS: `Hide`,
  READ_MORE: `Read more`
}
